import NewText from "@components/NewText";
import { addElement, delElement, logout } from "utils/firebase";
import Breaker from "@components/Breaker";
import React, { useContext, useState } from "react";
import { ACNH_Element } from "utils/class-types";
import {
  asType,
  capitalize,
  mapObject,
  parseCSS,
  parseNumber,
  parsePrice,
} from "scripts/FunctionsBundle";
import { GlobalContext } from "App";
import styled, { css } from "styled-components";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
type _Capturapedia = import("utils/class-types").Capturapedia;
// AdminScreen => Rename all instances to use
type AdminScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _AdminScreen = (props: AdminScreenProps) => {
  const {
    get: { Capturapedia },
    update: { Capturapedia: updateCapt },
    user,
  } = useContext(GlobalContext);

  const [formData] = useState<{
    category: keyof _Capturapedia;
    objects: { [Property in keyof _Capturapedia]-?: _Capturapedia[Property] };
  }>({
    category: "bichos",
    objects: mapObject(ACNH_Element.classes, (cat, _, obj) => {
      return new obj[cat]();
    }),
  });

  const [submitting, setSubmitting] = useState(false);
  const [render, setRender] = useState(0);
  const [selectMode, setSelectMode] = useState(true);

  // ------------------------------------------------------------------------------------ HANDLE CHANGE
  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) {
    var variable: string = e.target.id;
    var value: string | number = e.target.value;

    if (e.target.name === "number") {
      value = parseNumber(value);
      console.log(value, e.target.value);
    }

    currentCategory.update({ [variable]: value });

    if (render >= 65530) setRender(-65530);
    else setRender((val) => val + 1);
  }

  // ------------------------------------------------------------------------------------ HANDLE SUBMIT
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    setSubmitting(true);

    var category = currentCategory;
    if (category === undefined) return;

    const { _specifics: _, ...data } = category;

    addElement(
      "animal-crossing-new-horizons",
      formData.category,
      category.name,
      data
    )
      .then(() => {
        alert("Cambios registrados!");
        updateCapt();
        setSubmitting(false);
      })
      .catch(() => {
        alert("Algo salió mal...");
        setSubmitting(false);
      });
  }

  // ------------------------------------------------------------------------------------ CHANGE BINARY
  function bin(str: string, pos: number, val?: number) {
    var chg = str[pos];
    if (chg === "0") chg = "1";
    else chg = "0";

    if (val) chg = "" + val;

    return str.slice(0, pos) + chg + str.slice(pos + 1);
  }

  // ------------------------------------------------------------------------------------ HANDLE DRAG
  function drag(
    e: React.DragEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
  ) {
    var evtype = asType<"change" | "dragstart" | "dragenter">(e.type);
    var eltype = asType<"month" | "hour">(e.target["name"]);
    var elindex = parseNumber(e.target["id"]);

    // Where to change state -> on change, on start drag
    if (
      evtype === "change" ||
      evtype === "dragstart" ||
      e.target["checked"] !== selectMode
    ) {
      currentCategory[eltype] = bin(currentCategory[eltype], elindex);
      if (evtype === "dragstart") setSelectMode(!e.target["checked"]);
    }

    if (render >= 65530) setRender(-65530);
    else setRender((val) => val + 1);
  }

  // hot data
  const categoryName = formData.category;
  const currentCategory = formData.objects[categoryName];

  return (
    <div className={props.className + " screen"}>
      <div className={"container"}>
        <NewText
          _text={`
          |{@:title-2 al-center,?:p}|Capturapedia & Lista de venta|| ;;
          ;;
          |{@:subtitle-1}||{*}|INSTRUCCIONES: ||Selecciona un elemento de la siguiente lista para cargarlo en el formulario.
          Después, modifica los campos y guarda la información para modificar la base de datos.
          Si se escribe un nombre de un elemento que no exista todavía, agrega sus valores y guárdalos para crearlo.
          Para eliminar un elemento del listado, pulsa el botón correspondiente desde la lista desplegada. ;;
          ;;
          |{*}|Elementos existentes: ||||
        `}
        />

        <div
          style={{
            maxHeight: "16rem",
            overflow: "auto",
          }}
        >
          {Object.keys(Capturapedia).length <= 0 ? (
            <div
              style={{
                maxHeight: "16rem",
                overflow: "auto",
                border: "3px black solid",
                borderRadius: "2px",
                padding: "0.5rem 2rem",
              }}
            >
              <NewText
                _text={"Loading..."}
                _type={"subtitle"}
                _align="center"
                _this={{ _bold: {} }}
              />
            </div>
          ) : (
            <table className={"cool-table"}>
              <thead>
                <tr>
                  {[
                    "Categoría",
                    "Nombre",
                    "Precio",
                    "Imagen",
                    "Consideraciones",
                    "Eliminar",
                  ].map((tag, i) => {
                    return (
                      <td key={i}>
                        <NewText
                          _text={tag}
                          _del_margin
                          _this={{ _bold: {} }}
                        />
                      </td>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {Object.keys(Capturapedia).map((category) => {
                  return Capturapedia[category].map(
                    (element: any, catind: number) => {
                      var temp = asType<ACNH_Element>(element);
                      return (
                        <tr
                          key={catind}
                          onClick={() => {
                            formData.objects[category]?.update?.(temp);
                            formData.category = asType<any>(category);
                            setRender((val) => val + 1);
                          }}
                        >
                          {[
                            "category",
                            "name",
                            "price",
                            "image",
                            "considerations",
                          ].map((key, ind) => {
                            return (
                              <td key={ind}>
                                <NewText
                                  _text={
                                    key === "category"
                                      ? capitalize(category)
                                      : key === "price"
                                      ? parsePrice(temp[key])
                                      : temp[key]
                                  }
                                  _del_margin
                                />
                              </td>
                            );
                          })}
                          <td style={{ textAlign: "center" }}>
                            <button
                              className={"eliminar"}
                              onClick={() => {
                                delElement(
                                  "animal-crossing-new-horizons",
                                  category,
                                  temp.name
                                ).then(() => {
                                  console.log("Successfully deleted");
                                  updateCapt();
                                  setRender((val) => val + 1);
                                });
                              }}
                            >
                              &#x1f5d1;
                            </button>
                          </td>
                        </tr>
                      );
                    }
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <Breaker _size={"4rem"} />

      <form onSubmit={handleSubmit}>
        {/* ###### Información General ###### */}
        <fieldset className="field-legend">
          <legend>
            <NewText
              _text={"Información general"}
              _type={"subtitle"}
              _del_margin
              _this={{ _bold: {} }}
            />
          </legend>

          {/* ### Categoria ### */}
          <label style={{ marginRight: "1rem" }} htmlFor={"category"}>
            <NewText _text={"Categoría: "} _type={"subtitle"} _del_margin />
          </label>
          <select
            id={"category"}
            onChange={(e) => {
              formData.category = asType<"bichos">(e.target.value);
              setRender(render + 1);
            }}
            value={formData.category}
            style={{ fontSize: "1.25rem", marginRight: "3rem" }}
          >
            <option disabled>- Selecciona -</option>
            {Object.keys(formData.objects).map((category, index) => (
              <option key={index} value={category}>
                {capitalize(category)}
              </option>
            ))}
          </select>

          {/* ### Nombre ### */}
          <label style={{ marginRight: "1rem" }} htmlFor={"name"}>
            <NewText _text={"Nombre: "} _type={"subtitle"} _del_margin />
          </label>
          <input
            id={"name"}
            placeholder={"< Empty >"}
            className={currentCategory.name ? "" : "invalid"}
            onChange={handleChange}
            value={currentCategory.name}
            required
            autoComplete={"off"}
            style={{
              fontSize: "1.25rem",
              marginRight: "3rem",
              padding: "0rem 0.3rem",
              width: "25rem",
            }}
          />

          {/* ### Precio ### */}
          <label style={{ marginRight: "1rem" }} htmlFor={"price"}>
            <NewText _text={"Precio: "} _type={"subtitle"} _del_margin />
          </label>
          <input
            id={"price"}
            name={"number"}
            placeholder={"< Empty >"}
            onChange={handleChange}
            value={parsePrice(currentCategory.price)}
            required
            autoComplete={"off"}
            maxLength={"$999,999".length}
            style={{
              fontSize: "1.25rem",
              marginRight: "3rem",
              padding: "0rem 0.3rem",
            }}
          />
        </fieldset>

        {/* ###### Horario de aparicion ###### */}
        {currentCategory["month"] !== undefined &&
        currentCategory["hour"] !== undefined ? (
          <fieldset className="field-legend">
            <legend>
              <NewText
                _text={"Horario de aparición"}
                _type={"subtitle"}
                _del_margin
                _this={{ _bold: {} }}
              />
            </legend>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "1rem",
                }}
              >
                {/* ###################### MESES ###################### */}
                {new Array<number>(12).fill(1).map((_, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: "0.5rem",
                        width: "3rem",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      key={index}
                    >
                      <label
                        htmlFor={`${index}-month`}
                        style={{ position: "absolute", pointerEvents: "none" }}
                      >
                        <NewText
                          _text={
                            [
                              "Ene",
                              "Feb",
                              "Mar",
                              "Abr",
                              "May",
                              "Jun",
                              "Jul",
                              "Ago",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dic",
                            ][index]
                          }
                          _this={{ _bold: {} }}
                          _del_margin
                        />
                      </label>
                      <input
                        type={"checkbox"}
                        id={`${index}-month`}
                        name={"month"}
                        draggable
                        onDragEnter={drag}
                        onDragStart={drag}
                        onChange={drag}
                        checked={currentCategory["month"][index] === "1"}
                        style={{ width: "2.5rem", height: "2.5rem" }}
                      />
                    </div>
                  );
                })}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "1rem",
                }}
              >
                {/* ###################### HORAS ###################### */}
                {new Array<number>(24).fill(1).map((_, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: "0.5rem",
                        width: "3rem",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      key={index}
                    >
                      <label
                        htmlFor={`${index}-hour`}
                        style={{ position: "absolute", pointerEvents: "none" }}
                      >
                        <NewText
                          _text={(index > 9 ? index : "0" + index) + ":00"}
                          _del_margin
                          _this={{
                            _bold: {},
                          }}
                        />
                      </label>
                      <input
                        type={"checkbox"}
                        id={`${index}-hour`}
                        name={"hour"}
                        draggable
                        onDragEnter={drag}
                        onDragStart={drag}
                        onChange={drag}
                        checked={currentCategory["hour"][index] === "1"}
                        style={{ width: "2.5rem", height: "2.5rem" }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </fieldset>
        ) : (
          <></>
        )}

        {/* ###### Especificaciones ###### */}
        {Object.keys(currentCategory!._specifics).length > 0 ? (
          <fieldset className="field-legend">
            <legend>
              <NewText
                _text={"Especificaciones"}
                _type={"subtitle"}
                _this={{ _bold: {} }}
                _del_margin
              />
            </legend>

            {/* ### Crear un selector para cada especificación ### */}
            {Object.keys(currentCategory!._specifics).map((specific, index) => {
              return (
                <div key={index}>
                  <label style={{ marginRight: "1rem" }} htmlFor={specific}>
                    <NewText
                      _text={
                        specific[0].toUpperCase() + specific.slice(1) + ": "
                      }
                      _type={"subtitle"}
                      _del_margin
                    />
                  </label>
                  <select
                    id={specific}
                    onChange={handleChange}
                    value={currentCategory[specific]}
                    style={{ fontSize: "1.25rem", marginRight: "3rem" }}
                  >
                    <option disabled>- Selecciona -</option>
                    {currentCategory!._specifics[specific].map(
                      (option: string, index: number) => (
                        <option key={index} value={option}>
                          {option[0].toUpperCase() + option.slice(1)}
                        </option>
                      )
                    )}
                  </select>
                </div>
              );
            })}
          </fieldset>
        ) : (
          <></>
        )}

        {/* ###### Información adicional ###### */}
        <fieldset className={"field-legend"}>
          <legend>
            <NewText
              _text={"Información adicional"}
              _type={"subtitle"}
              _this={{ _bold: {} }}
              _del_margin
            />
          </legend>
          <label style={{ marginRight: "1rem" }} htmlFor={"considerations"}>
            <NewText
              _text={"Consideraciones: "}
              _type={"subtitle"}
              _del_margin
            />
          </label>
          <input
            id={"considerations"}
            placeholder={"< Empty >"}
            onChange={handleChange}
            value={currentCategory.considerations}
            autoComplete={"off"}
            style={{
              fontSize: "1.25rem",
              marginRight: "3rem",
              padding: "0rem 0.3rem",
              width: "25rem",
            }}
          />
        </fieldset>

        <button type={"submit"} disabled={submitting}>
          <NewText
            _text={"Actualizar información"}
            _type={"button"}
            _this={{ _bold: {} }}
          />
        </button>

        <NewText
          _text={
            "|{*}|Nota||: La información se modificará en caso de que ya exista, o se creará en caso contrario"
          }
          _type={"body"}
        />
      </form>

      <Breaker />

      <div className={"container flex"}>
        <NewText
          _text={"Log Out"}
          _this={{
            _bold: {},
            _converter: {
              _el: "button",
              _prop: {
                onClick: () => {
                  logout();
                },
              },
            },
            _custom: {
              _add: "button-2",
            },
          }}
          _del_margin
        />

        <NewText
          _text={"Current user: " + (user.email === "" ? "None" : user.email)}
          _this={{ _bold: {} }}
          _del_margin
        />
      </div>

      <Breaker />
    </div>
  );
};

// ################################ STYLES ################################
const AdminScreen = styled(_AdminScreen).attrs((props): AdminScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    .container,
    form {
      margin: 0px 2.5rem;
    }

    .flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }

    .flex > * {
      &:first-child {
        margin-right: 0.5rem;
      }

      &:last-child {
        margin-left: 0.5rem;
      }

      &:not(:last-child) &:not(:first-child) {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }
    }

    .invalid {
      border-color: #c90e0e;
      background-color: #a1757581;

      ::placeholder {
        color: #c90e0e;
      }
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default AdminScreen;
